export default "__VITE_ASSET__7f0c2d41__"